import { getListBrowserStore } from '@ts-private/list-browser';

const logsStore = getListBrowserStore({
  name: 'system-logs-browser',
  filterDefinitions: [
    {
      name: 'correlationId',
      caption: 'Logs.CorrelationId',
      type: 'text'
    },
    {
      name: 'message',
      caption: 'Logs.Message',
      type: 'text'
    },
    {
      name: 'startDate',
      caption: 'Logs.StartDate',
      type: 'date'
    },
    {
      name: 'startTime',
      caption: 'Logs.StartTime',
      type: 'time'
    },
    {
      name: 'endDate',
      caption: 'Logs.EndDate',
      type: 'date'
    },
    {
      name: 'endTime',
      caption: 'Logs.EndTime',
      type: 'time'
    },
    {
      name: 'level',
      caption: 'Logs.Level',
      type: 'select',
      underlyingType: 'number'
    },
    {
      name: 'onlyWithCorrelationId',
      caption: 'Logs.IncludeMessagesWithCorrelationIds',
      type: 'boolean'
    },
    {
      name: 'showLogEvent',
      caption: 'Logs.IncludeLogEvent',
      type: 'boolean'
    }
  ],
  orderByFields: [
    {
      caption: 'Logs.StartDate',
      value: 'StartDate'
    }
  ],
  pager: {
    orderBy: 'StartDate',
    direction: 'desc'
  }
});

export default logsStore;
